import _ from "lodash";
import PropTypes from "prop-types";
import { Box, Pagination } from "@mui/material";
import baseTheme from "../themes/baseTheme";
import FormControl from "../components/FormControl";
import { useState, useCallback } from "react";
import { useEffect } from "react";
import "../styles/Paginator.css";

const grey = baseTheme.palette.grey;
const blue = baseTheme.palette.blue;
const delay = 1000;
export default function Paginator({
  count,
  page: parentPage = 1,
  size = "small",
  disabled,
  margin,
  onChange: parentOnChange,
}) {
  const [page, setPage] = useState(parentPage);
  const debouncedOnChange = useCallback(_.debounce(parentOnChange, delay), []);

  useEffect(() => {
    if (page != parentPage) {
      debouncedOnChange(page);
    }
  }, [page]);
  useEffect(() => {
    if (!isNaN(parentPage) && parentPage >= 1 && parentPage <= count) {
      setPage(Number(parentPage));
    } else {
      setPage(1);
    }
  }, [parentPage, count]);
  function onChange(page) {
    page = page > count ? count : page;
    setPage(page);
  }

  return (
    <Box className="pagination-container" >
      <Pagination
        count={count}
        page={Number(page) === 0 ? 1 : Number(page)}
        shape="rounded"
        size={size}
        disabled={disabled}
        onChange={(event, page) => onChange(page)}
        sx={{
          margin,
          "& .MuiButtonBase-root": {
            color: grey[80],
          },
          "& .MuiButtonBase-root.Mui-selected": {
            color: grey[0],
            backgroundColor: blue[50],
          },
        }}
      />
      {/* <Box flexGrow={1} /> */}
      <FormControl
        label="Go to page"
        // sx={{backgroundColor:"#F9FAFB"}}
        variant="number"
        size="large"
        heighlight={"false"} //TODO:-Abdul add here!
        min={0}
        max={count}
        // value={(isNaN(page))? 1 : Number(page)}
        value={Number(page)}
        handleChange={onChange}
        labelPositioning="horizontal"
        width="5rem"
        disabled={disabled}
      />
    </Box>
  );
}

Paginator.propTypes = {
  /**
   * Total number of pages
   */
  count: PropTypes.number,
  /**
   *  Page selected
   */
  page: PropTypes.number,
  /**
   * Paginator size
   */
  size: PropTypes.string,
  /**
   * Page change handler
   */
  onChange: PropTypes.func.isRequired,
};

Paginator.defaultProps = {
  size: "small",
  disabled: false,
};
